import { Component, OnInit } from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {NotificationsService, ProjectService} from "@catcore/services";
import {isNullOrUndefined} from "util";
import {ProjectUnitsService} from "@catmodels/project-units/services/project-units.service";

@Component({
  selector: 'cat-project-unit-partnumbers',
  templateUrl: './project-unit-partnumbers.component.html',
  styleUrls: ['./project-unit-partnumbers.component.scss']
})
export class ProjectUnitPartnumbersComponent implements OnInit {

  private projectSubscription: Subscription;
  private unitSubscription: Subscription;
  private project = null;

  form: FormGroup;

  constructor(private projectService: ProjectService,
              private unitService: ProjectUnitsService,
              private notification: NotificationsService,
              private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      units: this.formBuilder.array([]),
    });
  }

  ngOnInit() {
    // first get the current project
    this.projectSubscription = this.projectService.getCurrentProject()
      .subscribe((project) => {
        const isActiveProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        if (isActiveProject) {
          this.dataTableInitialized = false;
          this.project = project;
          if (this.unitSubscription) {
            this.unitSubscription.unsubscribe();
          }
          this.unitSubscription = this.projectService.getAllUnits(this.project, true)
            .subscribe((units) => {
              console.log("Units", units);
              this.createDataTableItems(units);
              this.dataTableInitialized = true;
            });
        }
      });
  }

  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
  }

  tableItems: any[] = [];
  dataTableInitialized = false;

  columns = {
    unit: {field: 'unit', header: 'Unit'},
    unitpn: {field: 'unitpn', header: 'Unit P/N'},
    location: {field: 'location', header: 'Location ID'},
  };

  dataAvailable() {
    return !isNullOrUndefined(this.tableItems) && this.tableItems.length !== 0;
  }

  onSubmit(event) {
    const requests = [];

    const formArray = this.form.controls['units'] as FormArray;
    for (let i = 0; i < formArray.length; i++) {
      if (formArray.at(i).dirty) {
        const form = formArray.at(i);
        requests.push(this.unitService.update(form.value));
        formArray.at(i).markAsPristine();
      }
    }

    Observable.forkJoin(requests)
      .subscribe((multiple) => {
        this.notification.success('Update successful', 'Successfully updated ' + multiple.length + ' units');
      })
    ;
  }

  private createDataTableItems(items: any[]) {
    this.tableItems = [];
    const formArray = this.form.controls['units'] as FormArray;
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }

    items.forEach((unit) => {
      const formControl = this.formBuilder.group({
        id: ['', []],
        part_number: ['', []],
      });
      formArray.push(formControl);
      formControl.get('id').setValue(unit.id);
      formControl.get('part_number').setValue(unit.part_number);

      const data = {
        unit: unit.label,
        unitpn: unit.part_number,
        location: unit.location_address,
        partnumber_options: this.buildPartnumberOptions(unit),
        formControl: formControl
      };
      this.tableItems = [...this.tableItems, data];
    });
  }

  private buildPartnumberOptions(unit) {
    const options = [];
    if (unit.hasOwnProperty("physical_part_numbers")) {
      [unit.part_number, ...unit.physical_part_numbers].forEach((partnumber) => {
        if (options.find((p) => p.value === partnumber) === undefined) {
          options.push({value: partnumber, label: partnumber});
        }
      });
    }
    return options;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-partnumbers/components/project-unit-partnumbers/project-unit-partnumbers.component.ts